import { map } from "lodash-es";
import React from "react";
import { Helmet } from "react-helmet";
import { copy } from "shared/assets";

interface HeadProps {
  title?: string | string[];
  og?: {
    image?: string;
    title?: string;
    description?: string;
  };
}

export const Head: React.FC<HeadProps> = ({ title, og = {}, children }) => {
  return (
    <Helmet>
      {title && (
        <title>
          {typeof title === "string"
            ? `${title} | `
            : title.reduce((result, text) => `${result}${text} | `, "")}
          {copy.pageTitle.prefix}
        </title>
      )}
      {map(og, (content, key) => (
        <meta key={key} property={`og:${key}`} content={content} />
      ))}
      {children}
    </Helmet>
  );
};
